import React, { FC, ReactNode, useMemo, useEffect, useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import CookieContext from './context'
import type { Consent } from './context'
import CookieConsent from './CookieConsent'
import { STORAGE_KEY } from './constants'
import CookiePreferences from './CookiePreferences'
import { persistedConsent } from './utils'

interface CookieProviderProps {
  children: ReactNode
}

const CookieProvider: FC<CookieProviderProps> = ({ children }) => {
  const initialConsent: Consent = persistedConsent() ?? {
    essential: true,
    performance: false,
    functional: false,
    targetting: false,
  }

  const [showConsent, setShowConsent] = useState(false)
  const [showPreferences, setShowPreferences] = useState(false)
  const [values, setValues] = useState(initialConsent)

  const val = useMemo(
    () => ({
      openConsent: () => {
        setShowConsent(true)
      },
      closeConsent: () => {
        setShowConsent(false)
      },
      getConsent: () => {
        return values
      },
      updateConsent: (consent: Consent) => {
        setValues(consent)
      },
      openPreferences: () => {
        setShowPreferences(true)
        setShowConsent(false)
      },
      closePreferences: () => {
        setShowPreferences(false)
      },
      values,
    }),
    [values]
  )

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY)
    if (!consent) {
      setShowConsent(true)
    }
  }, [])

  return (
    <CookieContext.Provider value={val}>
      {children}
      <AnimatePresence>{showConsent && <CookieConsent />}</AnimatePresence>
      <AnimatePresence>{showPreferences && <CookiePreferences />}</AnimatePresence>
    </CookieContext.Provider>
  )
}

export default CookieProvider
